import { OnInit, Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSlideToggleChange } from "@angular/material";
import { OrgSettingsService } from "src/org-settings/org-settings.service";
import { ProcedureProtocolMessageDTO } from "src/DTOs/Organisations/Models/ProcedureProtocolMessageDTO";
import { SimpleDialogComponent } from "src/app/components/simple-dialog/simple-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { DisableConfirmationDialog } from "./disable-confirmation.dialog";
import { VisitTypeService } from "src/org-settings/visit-type.service";

@Component({
    selector: 'app-communication-preview-dialog',
    templateUrl: 'communication-preview.dialog.html',
    styleUrls: ['communication-preview.dialog.scss']
})
export class CommunicationPreviewDialog implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<CommunicationPreviewDialog>,
        private settingsService: OrgSettingsService,
        private dialog: MatDialog,
        private visitTypeService: VisitTypeService) {
        this.visitTypeId = data.selectedVisitTypeId;
    }

    visitTypeId: string;
    selectedDay: ProcedureProtocolMessageDTO;
    messages: ProcedureProtocolMessageDTO[] = [];
    selectedSmsContent: string = '';
    selectedEmailContent: string = '';

    ngOnInit(): void {
        if (this.visitTypeId) {
            this.visitTypeService.getVisitTypeMessages(this.visitTypeId).subscribe(
                (response: ProcedureProtocolMessageDTO[]) => {
                    this.messages = response;
                    if (response != null && response.length > 0)
                        this.selectedDay = response[0];
                    this.selectedSmsContent = response[0].MessageTemplates[0].SmsContent.split('{{').join('<span class="ptv">').split('}}').join('</span>');
                    this.selectedEmailContent = response[0].MessageTemplates[0].EmailContent.split('{{').join('<span class="ptv">').split('}}').join('</span>');
                },
                error => {
                    console.log(error);
                });
        }
    }

    onToggleChange(event: MatSlideToggleChange) {
        if (event.checked) {
            this.enableMessage(event);
        } else {
            this.showModal(event);
        }
    }

    private showModal(event: MatSlideToggleChange) {
        const dialogRef = this.dialog.open(DisableConfirmationDialog, {
            width: '400px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.enableMessage(event);
            }
            else {
                this.selectedDay.Enabled = true;
                event.source.checked = true;
                event.source.disabled = false;
            }
        });
    }

    private enableMessage(event: MatSlideToggleChange) {
        this.settingsService.enableProcedureProtocolMessage(this.selectedDay.ProcedureProtocolId, this.selectedDay.Id, { Enabled: event.checked })
            .subscribe(() => {
                this.selectedDay.Enabled = event.checked;
                event.source.disabled = false;
            }, err => {
                event.source.disabled = false;
            });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onDayItemClick(day: ProcedureProtocolMessageDTO): void {
        this.selectedDay = day;
        this.selectedSmsContent = day.MessageTemplates[0].SmsContent.split('{{').join('<span class="ptv">').split('}}').join('</span>');
        this.selectedEmailContent = day.MessageTemplates[0].EmailContent.split('{{').join('<span class="ptv">').split('}}').join('</span>');
    }
}